// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createLaborRateHistory} from '../../shared/repositories';

export const createLaborRateHistoryReport = () =>
    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const appState = getState();

            const postArgs = Object.freeze({
                days: appState.reports.laborRateHistory.historyToDisplay
            });

            const data = await createLaborRateHistory(postArgs);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_LABOR_RATE_HISTORY_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetLaborRateHistoryReport = () => ({
    type: actions.RESET_LABOR_RATE_HISTORY_REPORT
});



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/action-creators/report.js